import ContentLoader from "../../../../components/general/contentLoader/contentLoader";
import { parseMultiple } from '../../../../helpers/parse'
import { connect } from 'react-redux'
import NotFound from "../../../../pages/notFound/notFound";
import PermissionHOCDefault from './permissionHOC.default'
import React from "react";
import { parsePermission } from "../../types/parse";

const mapStateToProps = (state) => ({
	loading: state.permissions.get('loading'),
	currentUserPermissions: parseMultiple(state.permissions.get('currentUser'), parsePermission)
})

const HOC = connect(mapStateToProps, null)(PermissionHOCDefault)

const NotAllowedComponent = () => {
	return (
		<div className={'bg-container contained-page'} style={{ textAlign: "center" }}>
			<NotFound/>
		</div>
	)
}

const LoadingComponent = () => {
	// const {t} = useTranslation(PAGE_LOGIN)
	return (
		<ContentLoader loading/>
		// <div className={'bg-container contained-page'}>
		//     {t('loading')}...
		// </div>
	)
}

export function withPermissionHOC(WrappedComponent, requiredPermissions) {
	return class extends React.Component {
		render() {
			return (
				<HOC
					requiredPermissions={requiredPermissions}
					notAllowedComponent={NotAllowedComponent}
					loadingComponent={LoadingComponent}
				>
					<WrappedComponent
						{...this.props}
					/>
				</HOC>
			)
		}
	}
}

export default HOC